import type { ReactElement } from 'react';
import type { RunningNowListItem } from '@kirin/api-client/contracts/shadow-ai-running-now';
import { ProcessDetails } from '@/components/shared/running-processes';

export function ExpandedProcessRow({
  row,
}: {
  row: RunningNowListItem;
}): ReactElement {
  const hasExtras = !!row.extras && Object.keys(row.extras).length > 0;
  const hasDetails =
    row.binaryPath || row.commandLine || row.parentName || hasExtras;

  if (!hasDetails) {
    return (
      <span className="text-xs text-muted-foreground pl-8">
        No additional details
      </span>
    );
  }

  return (
    <div className="pl-8">
      <ProcessDetails process={row}>
        {hasExtras && row.extras ? (
          <>
            {Object.entries(row.extras).map(([k, v]) => (
              <div key={k} className="flex items-baseline gap-1 min-w-0">
                <span className="text-muted-foreground shrink-0">{k}:</span>
                <code className="bg-muted px-1 py-0.5 rounded truncate block">
                  {v}
                </code>
              </div>
            ))}
          </>
        ) : null}
      </ProcessDetails>
    </div>
  );
}
